/**
 * The address that shows one desktop session on the /desktop page (2026-10-06, PR 4 of the DocuSign fix).
 *
 * A computer run's card and the sign-in window's "open the live desktop" both put the person on THAT session,
 * so both build its address here. It imports nothing: the run card is rebuilt inside the chat reducer, and the
 * sign-in window is its own on-demand chunk, so neither may pull anything else in with it.
 */

/** The browser-service's own session-id charset (server.ts mints `desktop-<ms>-<base36>`; the warm slot is
 *  `desktop-warm-…`). */
export const DESKTOP_SESSION_ID_RE = /^desktop-[a-z0-9-]{6,64}$/i;

/** One of OUR workstation origins, optionally with its /browser-api path: the shape the desktop page takes on a
 *  `svc=` arrival, before it asks whether the host is one of this person's own (workstationSvc.ts). */
export const WORKSTATION_SVC_RE = /^https:\/\/(?:\d{1,3}-){3}\d{1,3}\.sslip\.io(?:\/browser-api)?$/i;

/** `/desktop?session=<id>[&svc=<base>]`, or null when the data cannot name a session the page would accept.
 *  A base of any other shape is left out: the page then shows the session on the person's own workstation. */
export function desktopSessionHref(data: { sessionId?: unknown; svc?: unknown }): string | null {
  const id = typeof data.sessionId === 'string' ? data.sessionId.trim() : '';
  if (!DESKTOP_SESSION_ID_RE.test(id)) return null;
  const svc = typeof data.svc === 'string' ? data.svc.trim().replace(/\/+$/, '') : '';
  const svcPart = svc && WORKSTATION_SVC_RE.test(svc) ? `&svc=${encodeURIComponent(svc)}` : '';
  return `/desktop?session=${encodeURIComponent(id)}${svcPart}`;
}
